var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['ring-container'],style:(_vm.containerStyle)},[_c('div',{class:['ring'],style:(_vm.ringStyle)}),_c('div',{staticClass:"inner-circle",style:(_vm.innerCircleStyle)}),_c('div',{staticClass:"center-text",style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.percentage)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }